/* eslint-disable */
import { useRef, useState, useEffect, useContext } from "react";
import AuthContext from "../../../../context/AuthProvider";
import axios from "axios";
import Cookies from "js-cookie";
import Page from "../../Page";
import * as Icon from "react-bootstrap-icons";
import logo from "../../../../assets/Vector.svg";
import fb from "../../../../assets/fb.png";
import gp from "../../../../assets/gp.png";
import ln from "../../../../assets/in.png";
import "./Login.css";
import { useNavigate, Link } from "react-router-dom";
import { Icons } from "react-toastify";
import Toast from "../../../assetLibComponents/shared/Toast";
import "react-responsive-carousel/lib/styles/carousel.min.css";

//Redux-imports
import { getLoginContent } from "../../../../redux/actions/loginActions";
import { useDispatch, useSelector } from "react-redux";

const ResetPassword = (props) => {
  const dispatch = useDispatch();
  const authCtx = useContext(AuthContext);
  const RESET_URL = authCtx.resetUrl;
  const [passwordCheck, setPasswordCheck] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [password, setPassword] = useState("");
  const [authToken, setAuthToken] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams(window.location.search);
    const mail = queryParams.get("mail");
    if (password === "" || confirmPassword === "") {
      Toast(password === "" ? "Please enter the password" : "Please enter the confirm password", "E");
      return;
    }
    if (passwordCheck === true) {
      return;
    }
    setButtonLoader(true);
    try {
      const response = await axios.post(RESET_URL, {
        email:mail,
        password:password,
        confirm_password:confirmPassword
      });
      if (response?.data?.statusCode === "401") {
         Toast(response?.data?.message ? response?.data?.message : response?.data?.response, "E");
        setButtonLoader(false);
      } else if (response?.data?.statusCode === "200") {
          Toast(response?.data?.message ? response?.data?.message : response?.data?.response, "S");
          navigate("/")
          setButtonLoader(false);
      } else {
        Toast(response?.data?.message ? response?.data?.message : response?.data?.response, "E");
        setButtonLoader(false);
      }
      setConfirmPassword("");
      setPassword("");
    } catch (err) {
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    setAuthToken(authCtx.auth);
  }, [setAuthToken, authCtx.auth, authToken]);

  useEffect(() => {
    dispatch(getLoginContent());
  }, []);

  let navigate = useNavigate();

  const title = props.title;
  useEffect(() => {
    document.title = `Get Started with Zoi | ${title}`;
    window.scrollTo(0, 0);
  }, [title, navigate]);

  return (
    <div title={props.title} className="mt-10">
    <div>
        <form action="#" method="POST" className="space-y-6">
        <div>
            <label
            htmlFor="password"
            className="block text-sm font-medium leading-6 text-gray-900"
            >
            Password
            </label>
            <div className="mt-2">
            <input
                type="password"
                onChange={(e) => {
                  const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
                  if (regex.test(e.target.value) || e.target.value.length < 1 || e.target.value.length === null ) {
                      setPasswordCheck(false);
                  } else {
                      setPasswordCheck(true);
                  }
                  setPassword(e.target.value)
                }}
                value={password}
                placeholder="Password"
                id="password"
                name="password"
                autoComplete="current-password"
                required
                className={"block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"+(passwordCheck === true ? " focus:ring-red-700 ":" focus:ring-[var(--brand-primary)] ")}
            />
            </div>
          </div>
          
          {passwordCheck === true && <p style={{marginTop:"5px"}} className="text-red-700 text-[10px]">Password must be at least 8 characters long and include at least one letter, one number, and one special character.</p>}    


        <div>
            <label
            htmlFor="confirm"
            className="block text-sm font-medium leading-6 text-gray-900"
            >
            Confirm Password
            </label>
            <div className="mt-2">
            <input
                type="password"
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                placeholder="Confirm Password"
                id="confirm"
                name="confirm"
                autoComplete="current-password"
                required
                className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
            />
          </div>
        </div>

        <div>
            <button
            onClick={handleSubmit}
            type="submit"
            className="flex w-full h-[33px] justify-center rounded-md bg-[var(--brand-primary)] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
            >
              {buttonLoader ? <div className="login-dual-ring"></div> : 'Submit'}
            </button>
        </div>
        </form>
    </div>
    </div>
  );
};

export default ResetPassword;
